import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import Dashboard from "./dashboard";
import Customers from "./customers";
import CustomerDetails from "./customerDetails";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import App from "grommet/components/App";
import Box from "grommet/components/Box";
import Split from "grommet/components/Split";

class LoggedIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true
    };
  }

  componentDidMount() {
    console.log("user is authenticated.");
  }

  render() {
    return (
      <App>
        <Split priority="left" flex="right">
          <Box
            justify="center"
            pad="medium"
            style={{ padding: "15px 0", width: "70px", height: "inherit" }}
          >
            <Sidebar />
          </Box>
          <Box justify="center" pad="small">
            <Header />
            <main>
              <Switch>
                <Route exact path={`/app`} component={Dashboard} />
                <Route path={`/app/dashboard`} component={Dashboard} />
                <Route path={`/app/customers`} component={Customers} />
                <Route path={`/app/customer/:id`} component={CustomerDetails} />
              </Switch>
            </main>
          </Box>
        </Split>
      </App>
    );
  }
}

export default LoggedIn;



// WEBPACK FOOTER //
// ./src/containers/loggedIn/index.js